import { nanoid } from "nanoid";

const USER_ID_KEY = "story-builder-user-id";

/**
 * Stable persistent user identity for web (localStorage).
 */
export async function getClientUserId(): Promise<string> {
  let id = localStorage.getItem(USER_ID_KEY);
  if (!id) {
    id = `user-${nanoid()}`;
    localStorage.setItem(USER_ID_KEY, id);
  }
  return id;
}
